import Component from '@glimmer/component'
import { UnderlineTabButton } from 'teacher-ui-client/components/underline-tab/button'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'

interface Signature {
  Element: HTMLButtonElement
  Args: {
    tabId: string
    imageUrl: string
    imageAlt: string
    isActive: boolean
    title: string
  }
}

export class PrintablesTab extends Component<Signature> {
  get themeKey() {
    return this.tabIdToThemeKey(this.args.tabId)
  }

  tabIdToThemeKey(tabId: string): ThemeKeys {
    switch (tabId) {
      case 'printables-tab-reading':
        return ThemeKeys.blue
      case 'printables-tab-reader':
        return ThemeKeys.darkBlue
      case 'printables-tab-maths':
        return ThemeKeys.green
      case 'printables-tab-writing':
        return ThemeKeys.darkBlue
      default:
        return ThemeKeys.default
    }
  }
  <template>
    <UnderlineTabButton
      data-test-printables-tab={{@tabId}}
      @active={{@isActive}}
      @themeKey={{this.themeKey}}
      class="flex flex-col items-center whitespace-nowrap"
      ...attributes
    >
      <img src={{@imageUrl}} alt={{@imageAlt}} class="h-14" />
      <h4 class="inline">{{@title}}</h4>
    </UnderlineTabButton>
  </template>
}

export default PrintablesTab
